import React from 'react';
import { BalloonPops } from '../BalloonAnimation';
import { Logo2 } from '../../blocks/Logo2';
import { Typography, Box, Link } from '@mui/material';
import styles from './ErrorPage.module.scss';

export type ErrorPageProps = {
	statusCode: number;
};

const ErrorPage = ( { statusCode }: ErrorPageProps ) => {
	const copy =
		statusCode === 401
			? 'You do not have permission to view this document.'
			: 'The page you\'re looking for can\'t be found.';

	return (
		<main>
			<Logo2 />

			<Box data-cy='error-page' className={ styles.container }>
				<Typography variant='h1' className={ styles.oops }>
					Oops
				</Typography>
				<Typography>{ copy }</Typography>
				<Typography>
					Click
					<Link href='/'> here </Link>
					to return home!
				</Typography>
				{ statusCode && (
					<Typography data-cy='error-page-status-code'>
						Error code: { statusCode }
					</Typography>
				) }
				<BalloonPops looping={ false } />
			</Box>
		</main>
	);
};

export default ErrorPage;
